import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import {
  replaceBucketUrlWithCdnUrl,
  fetchCurrencySymbol
} from '../src/helper/filter'
import '@/assets/css/tailwind.css'
import 'view-design/dist/styles/iview.css'
import VueMeta from 'vue-meta'
import VueCookies from 'vue-cookies'
import firebase from 'firebase/app'
import config from './config'
import { fetchCat } from '@/helper/permission.helper'

firebase.initializeApp(config.firebase)

import { locale } from 'view-design'
import lang from 'view-design/dist/locale/en-US'
locale(lang)

Vue.use(VueMeta)
Vue.use(VueCookies)
Vue.filter('replaceBucketUrlWithCdnUrl', replaceBucketUrlWithCdnUrl)
Vue.filter('fetchCurrencySymbol', fetchCurrencySymbol)

Vue.config.productionTip = false
Vue.prototype.$bus = new Vue()

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

declare const ga: any
if (config.googleAnalyticId) {
  ga('create', config.googleAnalyticId, 'auto')
  router.afterEach((to, from) => {
    const cat = fetchCat()
    if (to.name !== from.name) {
      ga('set', 'page', to.name)
      ga('send', 'pageview')
      if (cat) {
        ga('send', 'event', 'pageview', to.name, cat.locationId, 1)
      }
    }
  })
}

if ('serviceWorker' in navigator) {
  navigator.serviceWorker
    .register('/membership-sw.js', { scope: '.' })
    .then(registration => {
      console.log(registration)
    })
}
